import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getPortfolioTradingConnectionOrders } from "../service";
import { PAGE_SIZE } from "utils/constants";

export const useStrategyOrders = (tradingConnectionId = "", search = "") => {
  const {
    data,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["strategyOrders", tradingConnectionId, search],
    queryFn: async ({ pageParam = 1 }) => {
      const params = { page: pageParam, size: PAGE_SIZE, search };
      const response = await getPortfolioTradingConnectionOrders(
        tradingConnectionId,
        params
      );

      return {
        data: response.data,
        currentPage: pageParam,
        totalPages: response.total_pages,
        totalCount: response.total_count,
        hasRecords: response.data.length > 0,
      };
    },
    getNextPageParam: (lastPage) => {
      return lastPage.currentPage < lastPage.totalPages
        ? lastPage.currentPage + 1
        : undefined;
    },
    enabled: tradingConnectionId !== "",
  });

  const orderData = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data?.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;
  const hasRecords = latestPage?.hasRecords ?? true;

  return {
    isLoading,
    isFetchingNextPage,
    orderData,
    totalPages,
    totalCount,
    currentPage,
    hasRecords,
    fetchNextPage,
    hasNextPage,
    refetch,
  };
};
